import { Component, EventEmitter, Input, Output, SimpleChanges, OnChanges } from "@angular/core";

@Component({
  selector: "app-password-input",
  templateUrl: "./password-input.component.html",
  standalone: false,
})
export class PasswordInputComponent implements OnChanges {
  @Input() matFormClass = "w-100"; // Material form class
  @Input() subscriptSizing = "fixed"; // Subscript sizing for mat-form-field
  @Input() label = "Password"; // Label for the input
  @Input() placeholder = "Enter password"; // Placeholder for the input
  @Input() inputId = "password-input"; // ID for the input
  @Input() required: boolean; // Required attribute
  @Input() disabled: boolean; // Disabled attribute
  @Input() passwordPolicy: PasswordPolicy = null; // For user password policies
  @Input() pattern: string = null; // Pattern for the input
  @Input() tooltip: string = null; // Tooltip for the input
  @Input() tooltipDisabled = false; // Whether the tooltip is disabled
  @Input() password = ""; // 2 way binding
  @Output() passwordChange = new EventEmitter<string>(); // 2 way binding
  @Input() confirmPassword = ""; // For confirm password input
  @Output() confirmPasswordMatches = new EventEmitter<boolean>(); // Emits true if confirm password matches the password

  isPasswordVisible = false;
  capsLockOn = false;

  toggleVisibility() {
    this.isPasswordVisible = !this.isPasswordVisible;
  }

  detectCapsLock(event: KeyboardEvent) {
    this.capsLockOn = event.getModifierState && event.getModifierState("CapsLock");
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ("confirmPassword" in changes) {
      this.confirmPasswordMatches.emit(this.password == changes["confirmPassword"].currentValue); // Check if passwords match
    }
  }

  onInputChange(value: string) {
    this.password = value;
    this.passwordChange.emit(this.password); // Emit the updated password
    this.confirmPasswordMatches.emit(this.password == this.confirmPassword); // Check if passwords match
  }

  get passwordPolicyPattern(): RegExp {
    if (this.passwordPolicy == null) {
      return null; // No password policy defined
    }

    let pattern = `^(?=.*\\d{${this.passwordPolicy.password_min_digits},})`; // Minimum number of numbers
    pattern += `(?=.*[A-Z]{${this.passwordPolicy.password_min_uppercase_chars},})`; // Minimum number of uppercase letters
    pattern += `(?=.*[!@#$%^&*\\-_.]{${this.passwordPolicy.password_min_special_chars},})`; // Minimum number of special characters
    pattern += `.{${this.passwordPolicy.password_min_length},}$`; // Minimum length

    return new RegExp(pattern);
  }
}

export interface PasswordPolicy {
  password_min_length: number;
  password_min_digits: number;
  password_min_uppercase_chars: number;
  password_min_special_chars: number;
}
